import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const { 
  FiBrain, FiPackage, FiImage, FiCamera, FiEdit3, FiCheck, FiShield, 
  FiZap, FiArrowRight, FiPlay, FiStar, FiUser, FiBriefcase, FiTrendingUp,
  FiLayout, FiSmartphone, FiMonitor, FiInstagram, FiFacebook, FiShoppingBag,
  FiX, FiChevronLeft, FiChevronRight, FiMaximize2
} = FiIcons;

const ASSETS = {
  LOGO_HORIZONTAL: "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768094698/Logo_Creator_qrhoxe.webp",
  LOGO_VERTICAL: "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768094844/Logo_Creator_Vertical_oeaocl.webp",
  PREVIEWS: [
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768094613/Preview_Aplikasi_1_sqdadc.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768094613/Preview_Aplikasi_2_gziowd.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768094613/Preview_Aplikasi_3_fef4ux.webp"
  ],
  GENERATED_LOGOS: [
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098684/11_bquhwm.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098683/6_v4r3if.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098683/7_wnmzuv.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098683/3_gzqtpn.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098683/5_kflwmd.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098682/2_ez5iyq.webp",
    "https://res.cloudinary.com/dqpuhk0h7/image/upload/v1768098682/1_kcnp6d.webp"
  ],
  CHECKOUT_URL: "https://checkout.xendit.co/od/ailogocreator"
};

const TESTIMONIALS = [
  {
    name: "Budi Santoso",
    role: "Owner 'Kopi Senja'",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=faces",
    text: "Awalnya ragu, tapi pas coba... GILA! Logo sekelas agency 5 juta cuma jadi dalam 1 menit. Mockupnya bikin brand saya kelihatan mahal banget."
  },
  {
    name: "Sarah Wijaya",
    role: "Freelance Designer",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces",
    text: "Jujur ini cheat code buat freelancer. Saya bisa handle 10+ klien sehari. Fitur filosofi brand & palet warnanya sangat membantu presentasi."
  },
  {
    name: "Andi Pratama",
    role: "Distro Clothing",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=faces",
    text: "Hemat jutaan rupiah. Biasanya bayar desainer 500rb per logo, ini 199rb udah dapet unlimited logo + mockup kaos. Best investment!"
  },
  {
    name: "Rina Hartono",
    role: "Tech Startup Founder",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=faces",
    text: "AI-nya pinter banget nangkep vibe industri teknologi. Logonya modern, clean, dan filosofis. Sangat recommended buat startup bootstrap."
  },
  {
    name: "Doni Kusuma",
    role: "Dropshipper",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=faces",
    text: "Wajib punya buat yang jualan online. Branding toko jadi lebih meyakinkan pembeli. Conversion rate toko saya naik sejak ganti logo pakai ini."
  }
];

const MOCKUP_ITEMS = [
  "Signage", "Botol", "Cup Plastik", "Pouch Kemasan", 
  "Tote Bag", "Kardus Box", "Kaos", "Hoodie", 
  "Dokumen", "Branding Mobil", "Website", "Instagram", 
  "Facebook", "Tiktok"
];

// Reusable Call to Action Button
const CTAButton = ({ className = "" }) => {
  const handlePayment = () => {
    window.open(ASSETS.CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <button 
      onClick={handlePayment}
      className={`group relative w-full bg-gradient-to-r from-orange-600 to-red-600 text-white text-xl md:text-2xl font-black py-4 px-6 md:py-6 md:px-12 rounded-2xl transition-all duration-300 hover:scale-[1.02] shadow-[0_0_30px_rgba(249,115,22,0.3)] hover:shadow-[0_0_50px_rgba(220,38,38,0.5)] ${className}`}
    >
      <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 text-center">
        AMBIL AKSES LIFETIME - Rp199.000
        <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-2 transition-transform hidden md:block" />
      </span>
    </button>
  );
};

// Reusable Video Trigger Button (New Card Style)
const VideoTriggerButton = ({ onClick, className = "" }) => (
  <div 
    className={`group relative bg-white/5 rounded-2xl p-4 cursor-pointer hover:bg-white/10 transition-all duration-300 border border-white/10 overflow-hidden flex items-center gap-5 backdrop-blur-sm ${className}`}
    onClick={onClick}
  >
    <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-blue-500/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
    <div className="relative z-10 w-14 h-14 bg-purple-600 rounded-full flex items-center justify-center shadow-lg shadow-purple-500/20 group-hover:scale-110 transition-transform flex-shrink-0">
      <SafeIcon icon={FiPlay} className="text-2xl text-white ml-1" />
    </div>
    <div className="relative z-10 text-left">
      <h3 className="text-lg font-bold text-white leading-tight mb-1">Lihat Demo Produk</h3>
      <p className="text-sm text-gray-400">Tonton bagaimana AI bekerja secara ajaib</p>
    </div>
  </div>
);

// Reusable Infinite Scroll Component with Drag Support
const InfiniteScroller = ({ children, speed = 1 }) => {
  const scrollerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const scroller = scrollerRef.current;
    let animationId;
    
    const scroll = () => {
      if (!isPaused && !isDragging && scroller) {
        if (scroller.scrollLeft >= scroller.scrollWidth / 2) {
          scroller.scrollLeft = 0;
        } else {
          scroller.scrollLeft += speed;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isPaused, isDragging, speed]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setIsPaused(true);
    setStartX(e.pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setIsPaused(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setIsPaused(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Scroll-fast
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div 
      ref={scrollerRef}
      className={`flex overflow-x-auto no-scrollbar gap-8 py-4 px-4 ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onTouchStart={() => setIsPaused(true)}
      onTouchEnd={() => setIsPaused(false)}
    >
      {/* Render children twice for seamless loop */}
      {children}
      {children}
    </div>
  );
};

// Logo Detail Modal
const LogoModal = ({ image, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 backdrop-blur-md"
        onClick={onClose}
      >
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="relative max-w-5xl max-h-[90vh] w-full flex items-center justify-center"
          onClick={e => e.stopPropagation()}
        >
          <button 
            onClick={onClose}
            className="absolute -top-12 right-0 md:-right-8 text-white/70 hover:text-white transition-colors bg-white/10 p-2 rounded-full"
          >
            <SafeIcon icon={FiX} className="text-2xl" />
          </button>
          <img 
            src={image} 
            alt="Logo Detail" 
            className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl shadow-purple-500/20"
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(null);
  
  // Controls for Main Video
  const videoRef = useRef(null);
  const playVideo = () => {
    setIsVideoPlaying(true);
    // Smooth scroll to video if needed, or just open overlay
    if (videoRef.current) {
        videoRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <div className="min-h-screen bg-black text-white selection:bg-purple-500/30 font-sans">
      <LogoModal 
        image={selectedLogo} 
        isOpen={!!selectedLogo} 
        onClose={() => setSelectedLogo(null)} 
      />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-purple-900/20 via-black to-blue-900/20">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 pt-10 text-center">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
            }}
            className="max-w-5xl mx-auto"
          >
            <motion.div variants={fadeInUp} className="mb-10 flex justify-center">
              <img 
                src={ASSETS.LOGO_HORIZONTAL} 
                alt="AI Logo Creator Logo" 
                className="h-16 md:h-20 drop-shadow-[0_0_15px_rgba(168,85,247,0.4)]"
              />
            </motion.div>

            <motion.h1 
              variants={fadeInUp}
              className="text-4xl md:text-6xl lg:text-7xl font-black mb-8 leading-[1.1]"
            >
              <span className="text-white">Hentikan Bayar </span>
              <span className="bg-gradient-to-r from-red-500 to-pink-500 bg-clip-text text-transparent">Jutaan</span>
              <span className="text-white"> ke Desainer.</span>
              <br />
              <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent">
                Ciptakan Identitas Brand Professional
              </span>
              <br />
              <span className="text-white">dalam </span>
              <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">60 Detik</span>
              <span className="text-white"> dengan AI!</span>
            </motion.h1>

            <motion.p 
              variants={fadeInUp}
              className="text-xl md:text-2xl text-gray-400 mb-10 max-w-4xl mx-auto leading-relaxed font-medium"
            >
              Bukan sekadar logo. Dapatkan filosofi brand, palet warna, hingga mockup produk nyata secara instan. 
              <span className="text-purple-400"> Tanpa langganan bulanan.</span>
            </motion.p>

            <div className="flex flex-col items-center gap-8 mb-12">
              <motion.div ref={videoRef} variants={fadeInUp} className="w-full max-w-2xl">
                {!isVideoPlaying ? (
                  <VideoTriggerButton onClick={() => setIsVideoPlaying(true)} />
                ) : (
                  <div className="relative aspect-video rounded-2xl overflow-hidden border border-purple-500/30 shadow-2xl shadow-purple-500/10">
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube.com/embed/40jfvU3h5NQ?autoplay=1"
                      title="AI Logo Creator Demo"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeInUp} className="w-full max-w-md px-4">
                <CTAButton />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-24 bg-white text-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-6xl font-black mb-10 tracking-tight">
              Masalah Bisnis Anda:
            </h2>
            <p className="text-2xl md:text-3xl text-gray-700 leading-snug font-medium">
              Sewa desainer mahal dan lama? Pakai aplikasi gratisan hasilnya pasaran? 
              <span className="text-black block mt-4 font-bold">Bisnis Anda butuh identitas yang kuat, cepat, dan murah.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Strategic CTA 1 */}
      <div className="bg-black py-16 px-6 border-b border-white/5">
        <div className="max-w-lg mx-auto flex flex-col items-center gap-6">
          <CTAButton />
          <div className="w-full max-w-sm">
             <VideoTriggerButton onClick={playVideo} />
          </div>
        </div>
      </div>

      {/* Logo Showcase Slider Section (Auto Scroll + Drag + Popup) */}
      <section className="py-24 bg-black overflow-hidden border-y border-white/5 relative">
        <div className="container mx-auto px-6 mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-black mb-4">
            Contoh Hasil <span className="text-purple-500">Generate Logo</span> AI
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto font-medium">
            Geser manual atau klik logo untuk melihat detail resolusi tinggi.
          </p>
        </div>

        <div className="relative w-full">
          <InfiniteScroller speed={0.8}>
            {ASSETS.GENERATED_LOGOS.map((logo, index) => (
              <div 
                key={index} 
                className="flex-shrink-0 w-64 h-64 md:w-80 md:h-80 rounded-2xl overflow-hidden border border-white/10 hover:border-purple-500/50 transition-all shadow-xl bg-zinc-900 group relative"
                onClick={() => !('ontouchstart' in window) && setSelectedLogo(logo)} 
                onMouseUp={(e) => {
                  setSelectedLogo(logo);
                }}
              >
                <img 
                  src={logo} 
                  alt={`Generated Logo ${index + 1}`} 
                  className="w-full h-full object-cover pointer-events-none"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                  <div className="bg-white/10 backdrop-blur-md p-3 rounded-full border border-white/20">
                    <SafeIcon icon={FiMaximize2} className="text-white text-2xl" />
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroller>

          <div className="flex justify-center gap-2 mt-8">
            <div className="flex gap-2 p-2 bg-white/5 rounded-full">
               <div className="w-2 h-2 rounded-full bg-purple-500 animate-pulse"></div>
               <div className="w-2 h-2 rounded-full bg-purple-500/50"></div>
               <div className="w-2 h-2 rounded-full bg-purple-500/30"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Who is this for? */}
      <section className="py-24 bg-zinc-950">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-black mb-6">Kenapa Anda Wajib Punya Tools Ini?</h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Business Owner Card */}
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-zinc-900 to-black p-8 md:p-10 rounded-[2.5rem] border border-white/10 hover:border-purple-500/30 transition-all"
            >
              <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-6 text-blue-400">
                <SafeIcon icon={FiBriefcase} className="text-4xl" />
              </div>
              <h3 className="text-3xl font-bold mb-4">Pemilik Usaha / UMKM</h3>
              <p className="text-gray-400 text-lg mb-6 leading-relaxed">
                Buat logo dan brand anda terlihat seperti brand profesional kelas premium hanya dalam hitungan detik. 
                <span className="text-white font-semibold"> Coba ribuan variasi tanpa biaya tambahan</span> hingga menemukan yang sempurna.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-gray-300">
                  <SafeIcon icon={FiCheck} className="text-blue-500 flex-shrink-0" /> Hemat budget desainer (Rp 2-5 Juta)
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <SafeIcon icon={FiCheck} className="text-blue-500 flex-shrink-0" /> Langsung dapat aset Mockup siap posting
                </li>
              </ul>
            </motion.div>

            {/* Freelancer Card */}
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-zinc-900 to-black p-8 md:p-10 rounded-[2.5rem] border border-white/10 hover:border-green-500/30 transition-all"
            >
              <div className="w-16 h-16 bg-green-500/20 rounded-2xl flex items-center justify-center mb-6 text-green-400">
                <SafeIcon icon={FiUser} className="text-4xl" />
              </div>
              <h3 className="text-3xl font-bold mb-4">Freelancer / Agency</h3>
              <p className="text-gray-400 text-lg mb-6 leading-relaxed">
                Terima hingga <span className="text-white font-semibold">ratusan orderan logo per hari</span>. 
                Kerjakan super cepat lengkap dengan filosofi brand identity & palet warna yang membuat klien terkesima.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-gray-300">
                  <SafeIcon icon={FiCheck} className="text-green-500 flex-shrink-0" /> Kecepatan kerja naik 100x lipat
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <SafeIcon icon={FiCheck} className="text-green-500 flex-shrink-0" /> Output profesional lengkap dengan Brand Kit
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Strategic CTA 2 */}
      <div className="bg-zinc-950 pb-16 px-6">
        <div className="max-w-lg mx-auto flex flex-col items-center gap-6">
          <CTAButton />
          <div className="w-full max-w-sm">
             <VideoTriggerButton onClick={playVideo} />
          </div>
        </div>
      </div>

      {/* App Preview Carousel */}
      <section className="py-24 bg-black border-y border-white/5">
        <div className="container mx-auto px-6 mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-black mb-4">
            Tampilan <span className="text-purple-500">Aplikasi</span>
          </h2>
          <p className="text-gray-400">Dashboard intuitif yang memudahkan siapa saja mendesain.</p>
        </div>
        
        <div className="relative w-full">
          {/* Reduced speed from 15 to 2 for smoother viewing */}
          <InfiniteScroller speed={2}>
            {ASSETS.PREVIEWS.map((img, i) => (
              <div 
                key={i}
                className="flex-shrink-0 h-[400px] md:h-[600px] w-auto rounded-2xl overflow-hidden border border-white/10 shadow-2xl hover:border-purple-500/50 transition-colors bg-zinc-900"
              >
                <img 
                  src={img} 
                  alt={`App Preview ${i+1}`} 
                  className="w-auto h-full object-contain pointer-events-none" 
                  draggable="false" 
                />
              </div>
            ))}
          </InfiniteScroller>
        </div>
      </section>

      {/* Mockup Capabilities */}
      <section className="py-24 bg-zinc-950">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-5xl font-black mb-6">
                Visualisasikan Brand di <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Dunia Nyata</span>
              </h2>
              <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                Jangan biarkan klien membayangkan. Tunjukkan bagaimana logo terlihat di produk asli. 
                Pilih dari puluhan template mockup premium atau upload foto produk Anda sendiri.
              </p>
              
              <div className="bg-zinc-900/50 p-6 rounded-2xl border border-white/10">
                <h4 className="text-white font-bold mb-4 flex items-center gap-2">
                  <SafeIcon icon={FiCamera} className="text-purple-500" />
                  Fitur Unggulan: Custom Photoshoot
                </h4>
                <div className="bg-black/50 p-4 rounded-xl border border-white/5 text-sm text-gray-400 italic">
                  "Upload foto kemasan polos anda, tulis instruksi: 'Letakkan logo di bagian tengah botol dengan efek emboss', dan AI akan mengerjakannya."
                </div>
              </div>
            </div>

            <div className="bg-zinc-900 p-8 rounded-[2rem] border border-white/10 shadow-2xl">
              <h3 className="text-xl font-bold mb-6 text-center text-gray-200">Library Mockup Tersedia:</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {MOCKUP_ITEMS.map((item, i) => (
                  <div key={i} className="bg-black/40 hover:bg-purple-600/20 border border-white/5 hover:border-purple-500/50 p-3 rounded-lg text-center transition-all cursor-default group">
                    <span className="text-sm font-medium text-gray-300 group-hover:text-white">{item}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-white/5">
                 <button className="w-full bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 hover:text-blue-300 py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2">
                   <SafeIcon icon={FiCamera} />
                   Dan Gunakan Foto Anda Sendiri
                 </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-gradient-to-b from-black to-zinc-950">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-16">
            Apa Kata Mereka?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((testi, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-zinc-900/40 p-8 rounded-3xl border border-white/5 relative hover:bg-zinc-900/60 transition-colors"
              >
                <div className="absolute top-8 right-8 text-yellow-500 flex gap-1">
                  {[...Array(5)].map((_, j) => <SafeIcon key={j} icon={FiStar} className="fill-current text-sm" />)}
                </div>
                <div className="flex items-center gap-4 mb-6">
                  <img src={testi.image} alt={testi.name} className="w-12 h-12 rounded-full border-2 border-purple-500" />
                  <div>
                    <h4 className="font-bold text-white">{testi.name}</h4>
                    <p className="text-xs text-purple-400 font-medium uppercase tracking-wider">{testi.role}</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed italic">"{testi.text}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing & Value Proposition (Enhanced) */}
      <section className="py-24 bg-black relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-600/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-5xl font-black mb-6">Jangan Lewatkan Kesempatan Ini</h2>
              <p className="text-xl text-gray-400 mb-8">
                Bayangkan kerugian Anda jika harus membayar desainer 
                <span className="text-red-500 font-bold line-through mx-2">Rp 5.000.000</span> 
                hanya untuk satu logo.
              </p>
            </div>

            <div className="bg-zinc-900 rounded-[2.5rem] p-8 md:p-16 border border-white/10 relative shadow-2xl overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-400 via-blue-500 to-purple-600"></div>
              
              <div className="absolute top-0 right-0 p-6">
                <div className="bg-red-600 text-white text-sm font-bold px-4 py-2 rounded-lg animate-bounce shadow-lg shadow-red-600/20">
                  ⚡ FLASH SALE: SISA 7 SLOT
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12 border-b border-white/5 pb-10">
                <div className="text-center md:text-left">
                  <p className="text-gray-400 mb-2">Harga Normal <span className="line-through decoration-red-500">Rp 999.000</span></p>
                  <div className="flex items-baseline gap-2 justify-center md:justify-start">
                    <span className="text-6xl font-black text-white">Rp 199rb</span>
                  </div>
                  <p className="text-green-400 font-bold mt-2 flex items-center gap-2 justify-center md:justify-start">
                    <SafeIcon icon={FiCheck} /> Sekali Bayar, Gratis Update Selamanya
                  </p>
                </div>
                <div className="text-center md:text-right">
                   <p className="text-sm text-gray-500 mb-4 max-w-xs mx-auto md:mx-0">
                     Investasi seharga "2 cangkir kopi" untuk aset branding bisnis senilai jutaan rupiah.
                   </p>
                   <div className="flex gap-2 justify-center md:justify-end">
                     <div className="bg-white/5 px-3 py-1 rounded border border-white/10 text-xs text-gray-400">Tanpa Langganan</div>
                     <div className="bg-white/5 px-3 py-1 rounded border border-white/10 text-xs text-gray-400">Tanpa Hidden Fee</div>
                   </div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-y-4 gap-x-8 mb-12">
                {[
                  'Unlimited Logo Generation (AI Gemini)',
                  'Full Branding Kit (Color, Typography, Philosophy)',
                  'Akses Mockup Generator Premium',
                  'Commercial License (Bebas Pakai)',
                  'Export High-Res PNG & Vector',
                  'Priority Support via WhatsApp'
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 shadow-lg shadow-green-500/20">
                      <SafeIcon icon={FiCheck} className="text-white text-xs" />
                    </div>
                    <span className="font-medium text-gray-300">{item}</span>
                  </div>
                ))}
              </div>

              <motion.div variants={fadeInUp} className="flex flex-col items-center">
                <div className="w-full max-w-2xl px-4">
                  <CTAButton />
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer (Simplified) */}
      <footer className="py-20 bg-zinc-950 border-t border-white/5">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-10">
            <img 
              src={ASSETS.LOGO_VERTICAL} 
              alt="AI Logo Creator" 
              className="h-32 opacity-80 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
            />
          </div>
          <p className="text-gray-500 font-medium">© 2026 AI Logo Creator. Empowering Business with AI.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;